import gql from 'graphql-tag'

export const ME = gql`
  query me {
    me {
      id
      suffix
      emp_id
      manager_name
      phone
      email
      address
    }    
  }
`
